import { render, staticRenderFns } from "./CreateRolesBottomSheet.vue?vue&type=template&id=b1abea16"
import script from "./CreateRolesBottomSheet.vue?vue&type=script&lang=js"
export * from "./CreateRolesBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports